/**
 * CSS custom property holding the height of the owner's draft-preview banner on
 * the public page (unset, so 0, when the banner is absent). Floating navs add it
 * to their `top` so they sit below the banner instead of covering it (JUB-154).
 */
export const PREVIEW_OFFSET_VAR = "--jb-preview-offset";

/** `top` value for a fixed element that must clear the preview banner. */
export const belowPreviewBanner = (top: string): string => `calc(var(${PREVIEW_OFFSET_VAR}, 0px) + ${top})`;
